import { render } from "./FooterElement.vue?vue&type=template&id=cab0bca2&scoped=true"
import script from "./FooterElement.vue?vue&type=script&lang=js"
export * from "./FooterElement.vue?vue&type=script&lang=js"

import "./FooterElement.vue?vue&type=style&index=0&id=cab0bca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab0bca2"]])

export default __exports__